import NextImage from 'next/image';
import { Box, Link } from '@chakra-ui/react';
import { createProfileImageUrl } from '../common/libs/user';

type AvatarSize = 'sm' | 'md';

const Avatar = ({
  profileImageUrl,
  size = 'md',
  customSize,
  mt = 0,
}: {
  profileImageUrl?: string;
  size?: AvatarSize;
  customSize?: number;
  mt?: number;
}) => {
  const w = customSize ? `${customSize}px` : size === 'sm' ? '10' : '20';
  const h = customSize ? `${customSize}px` : size === 'sm' ? '10' : '20';

  return (
    <Box
      pos="relative"
      w={w}
      h={h}
      minW={w}
      minH={h}
      borderRadius="full"
      overflow="hidden"
      mt={mt}
    >
      <NextImage
        src={profileImageUrl || '/images/avatar_default_gray.png'}
        alt="投稿者プロフィール"
        layout="fill"
        objectFit="cover"
      />
    </Box>
  );
};

export function ProfileImage({
  userId,
  discloseId,
  hasProfileImage = false,
  idBaseProfileUrl,
  updateDateEpochMilliseconds,
  size,
  customSize,
  mt,
  onClick,
}: {
  userId?: number;
  discloseId?: string | null;
  hasProfileImage?: boolean;
  idBaseProfileUrl: string | null;
  updateDateEpochMilliseconds?: number;
  size?: AvatarSize;
  customSize?: number;
  mt?: number;
  onClick?: () => void;
}) {
  const imageVersion = updateDateEpochMilliseconds;
  let profileImageUrl: string | undefined = undefined;
  if (hasProfileImage && userId) {
    profileImageUrl = createProfileImageUrl(userId, { version: imageVersion });
    if (idBaseProfileUrl) {
      profileImageUrl += `${imageVersion ? '&' : '?'}idurl=${encodeURIComponent(
        idBaseProfileUrl,
      )}`;
    }
  }

  return (
    <>
      {!userId && !discloseId ? (
        <Avatar size={size} mt={mt} />
      ) : (
        <Link
          href={`/profile/${discloseId || userId}`}
          onClick={onClick}
          title="投稿者プロフィール"
        >
          <Avatar
            profileImageUrl={profileImageUrl}
            size={size}
            mt={mt}
            customSize={customSize}
          />
        </Link>
      )}
    </>
  );
}

export default ProfileImage;
